export interface DocUploadStep {
  code: string;
  message: string;
  failMessage: string;
}

export const DocUploadSteps = {
  PENDING: {
    code: 'PENDING',
    message: 'Waiting to start',
    failMessage: 'Failed to start'
  } as DocUploadStep,
  CHECKING_FILE: {
    code: 'CHECKING_FILE',
    message: 'Checking file',
    failMessage: 'Failed file checking'
  } as DocUploadStep,
  CREATE_DOC: {
    code: 'CREATE_DOC',
    message: 'Waiting to upload',
    failMessage: 'Failed permissions checking'
  } as DocUploadStep,
  UPLOADING: {
    code: 'UPLOADING',
    message: 'Uploading doc',
    failMessage: 'Failed doc upload'
  } as DocUploadStep,
  CLEANING: {
    code: 'CLEANING',
    message: 'Cleaning doc',
    failMessage: 'Failed doc cleaning'
  } as DocUploadStep,
  DONE: {
    code: 'DONE',
    message: 'Upload finished',
    failMessage: ''
  } as DocUploadStep,

  get DISPLAY_ORDER(): DocUploadStep[] {
    return [this.CLEANING, this.UPLOADING, this.CREATE_DOC, this.CHECKING_FILE, this.PENDING, this.DONE];
  }
};



// WEBPACK FOOTER //
// ./src/common/models/DocUploadStep.ts